// src/admin/components/CreateOrganizationForm.tsx
import { CreateOrganizationData } from '@/organization/useOrganizations';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
} from '@mui/material';
import { useState } from 'react';

interface CreateOrganizationFormProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: CreateOrganizationData) => Promise<void>;
  isLoading?: boolean;
}

export function CreateOrganizationForm({
  open,
  onClose,
  onSubmit,
  isLoading = false,
}: CreateOrganizationFormProps) {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    void onSubmit({ name, description });
    setName('');
    setDescription('');
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
      <DialogTitle>Create Organization</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Stack>
            <TextField
              label={'Name'}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              fullWidth
            />
            <TextField
              label={'Description'}
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              multiline
              rows={4}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button type={'submit'} variant={'contained'} disabled={isLoading}>
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
